export default [
  {
    "id": "home",
    "name": "home",
    "path": "/"
  },
  {
    "id": "allCategories",
    "name": "todas-categorias",
    "path": "/categorias/"
  },
  {
    "id": "allBrands",
    "name": "todas-marcas",
    "path": "/marcas/"
  },
  {
    "id": "product",
    "name": "produto",
    "path": "/:slug/p/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "buybox",
    "name": "buybox",
    "path": "/:slug/m/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "404",
    "name": "not-found",
    "path": "/404/"
  },
  {
    "id": "404",
    "name": "internal-not-found-page",
    "path": "/error-404/"
  },
  {
    "id": "500",
    "name": "error",
    "path": "/500/"
  },
  {
    "id": "500",
    "name": "internal-error-page",
    "path": "/error-500"
  },
  {
    "id": "review-list",
    "name": "review-list",
    "path": "/review/:productId/:slug/:categoryId/:subCategoryId/"
  },
  {
    "id": "rate-product",
    "name": "rate-product",
    "path": "/r/:slug/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "promoter-offer",
    "name": "promoter-offer",
    "path": "/:slug/divulgador/oferta/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "seller-profile",
    "name": "seller-profile",
    "path": "/lojista/:sellerId"
  }
]
